import { Tooltip } from "src/components";

export interface SubmissionTooltipProps {
  formState: "INCOMPLETE" | "NO_CHANGE";
}

const SubmissionTooltip: React.FC<SubmissionTooltipProps> = ({ formState }) => {
  const message =
    formState === "INCOMPLETE" ? (
      <p>
        Please complete all required fields, including at least one invoice and the due date, before submitting the
        form.
      </p>
    ) : (
      <p>You must make changes before submitting the form</p>
    );

  return <Tooltip message={message} iconSize={16} />;
};

export { SubmissionTooltip };
